<template>
  <v-tooltip :color="$attrs.color" v-bind="$attrs" top :maxWidth="tooltipMaxWidth" contentClass="edn-tooltip">
    <template v-slot:activator="{ on }">
      <v-icon :color="iconColor" :size="iconSize" v-bind="$attrs" :small="iconSmall" :class="getActivatorClass" v-on="on" style="cursor: pointer"
        >mdi-information</v-icon
      >
    </template>
    <slot></slot>
  </v-tooltip>
</template>

<script>
export default {
  inheritAttrs: false,
  computed:{
    getActivatorClass: function(){
      let activatorClass = "evts-auto ";
      activatorClass += this.activatorClass;
      return activatorClass;
    }
  },
  data(){
    return{
      iconColor:"#737373"
    }
  },
  props: {
    iconSmall: {
      type: Boolean,
      default: () => false,
    },
    tooltipMaxWidth: {
      type: String,
      default: () => '450',
    },
    iconSize: {
      type: [Number, String],
      default: () => 10,
    },
    activatorClass: {
      type: String,
      default : () => {}
    }
  },
}
</script>
